<template>
  <page-outline :title="$t('Webheader.message_list')">
    <template slot="pageContent">
      <div class="listPage overflow-hidden">
        <b-row class="justify-content-start no-gutters">
          <b-button class="btn btnFilter" :disabled="activateSpinner"
            @click="onRefresh()">
            <i class="fa-light fa-rotate-right fs-14px"></i>
          </b-button>
        </b-row>

        <br />
        <b-row>
          <b-col md="12">
            <spinner v-if="activateSpinner"></spinner>
            <div v-else-if="items.length">
              <!-- DR : Changer de fixed à relative pour que les tables soient scrollable (pratique pour les users mobile/tablette)-->
              <b-table hover relative responsive :key="refreshList"
                class="mt-3"
                :fields="fields"
                :items="items"
                selectable select-mode="single">
                <template #cell(edit)="data">
                  <i class="fa-regular fa-pencil" @click="editNorm(data.item.id)"></i>
                </template>
                <template #cell(delete)="data">
                  <i class="fa-regular fa-trash" @click="deleteNorm(data.item.id)"></i>
                </template>
              </b-table>
            </div>
            <div class="text-center font-weight-bold" v-else>
              {{$t('common.no_result')}}
            </div>
          </b-col>
        </b-row>
        <b-row class="justify-content-end mt-3 no-gutters" v-if="canAddRTPNorm && !activateSpinner">
          <b-button
          @click="addNorm" variant="primary">
            <i class="fa-light fa-plus fs-17px"></i>
            <span>{{$t('common.routing.add_norm')}}</span>
          </b-button>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>

import _ from 'lodash'

import PageOutline from '@/components/common/PageOutline.vue'

import Spinner from '@/components/common/spinner.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'


export default {
  name: 'MessageList',
  components: {
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
  },
  computed: {
    canAddRTPNorm () {
      return this.$engine.rights.rightIs('rtp_norm_ajouter', true)
    }
  },
  data () {
    return {
      activateSpinner: false,
      fields: [
        { key: 'Provider', label: this.$t('common.routing.provider'), class: 'text-center table-condensed' },
        { key: 'Norm', label: this.$t('common.routing.norm'), class: 'text-center table-condensed' }
      ],
      items: [],
      refreshList: false
    }
  },
  created () {
    let that = this
    if (this.$engine.rights.rightIs('rtp_norm_editer', true)) {
      this.fields.push({ key: 'edit', label: that.$t('rights.edit'), class: 'text-center table-condensed col-1' })
    }
    if (that.$engine.rights.rightIs('rtp_norm_supprimer', true)) {
      that.fields.push({ key: 'delete', label: that.$t('common.del_label'), class: 'text-center table-condensed col-1' })
    }
    this.$bus.$on('language-changed', () => {
      that.fields = [
        { key: 'Provider', label: that.$t('common.routing.provider'), class: 'text-center table-condensed' },
        { key: 'Norm', label: that.$t('common.routing.norm'), class: 'text-center table-condensed' }
      ]
      if (that.$engine.rights.rightIs('rtp_norm_editer', true)) {
        that.fields.push({ key: 'id', label: that.$t('common.edit'), class: 'text-center table-condensed col-1' })
      }
      if (that.$engine.rights.rightIs('rtp_norm_supprimer', true)) {
        that.fields.push({ key: 'id', label: that.$t('common.del_label'), class: 'text-center table-condensed col-1' })
      }
      that.items = _.cloneDeep(that.items)
      that.refreshList = !that.refreshList
    })
    this.getList()
  },
  mounted () {
  },
  beforeDestroy () {
  },
  watch: {
  },
  methods: {
    addNorm () {
      loadPage(this, {url: '/routing/norm/form/-1'})
    },
    editNorm (id) {
      loadPage(this, {url: '/routing/norm/form/' + id})
    },
    getList () {
      this.activateSpinner = true
      let that = this
      this.$engine.routing.member.fetchNorm()
      .then(resp => {
        if (resp && resp.data && resp.data.Providers) {
          that.items = resp.data.Providers
          that.refreshList = !that.refreshList
        }
      })
      .catch(err => {
        errorMessageAlert(err, that)
      })
      .finally(() => {
        that.activateSpinner = false
      })
    },
    deleteNorm (id) {
      let that = this
      this.activateSpinner = true
      this.$engine.routing.member.deleteNorm({id: id})
      .then(resp => {
        that.items.splice(that.items.map(elem => elem.id).indexOf(id), 1)
        that.$f7.alert('', that.$i18n.t('common.routing.norm_deleted'))
      })
      .catch(err => {
        errorMessageAlert(err, that)
      })
      .finally(() => {
        that.activateSpinner = false
      })
    },
    onRefresh () {
      this.getList()
    }
  }
}

</script>
